'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { datadogRum } from '@datadog/browser-rum';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useRef } from 'react';
import { useExperimentOfferContext } from 'src/shared/providers/ExperimentOfferContext';
import { applyChaseLandingPage, isChaseLandingPageLink, listParamsThatFellBackToDefaults } from './applyLink';
const LINK_TYPES_TO_THE_OFFER = new Set(['APPLY_NOW_BUTTON', 'OFFER_NAME', 'PRODUCT_IMAGE']);
function isLinkToOffer(linkType: string | undefined, isReview: boolean | undefined) {
  return !isReview && LINK_TYPES_TO_THE_OFFER.has(linkType ?? '');
}
export function useChaseLandingPageLink(href, linkType, isReview) {
  const $ = _c(17);
  const offer = useExperimentOfferContext();
  const pathname = usePathname();
  const {
    skuViewedPayload
  } = useAnalyticsSkuViewedContext();
  const reportedRef = useRef(null);
  let t0;
  bb0: {
    if (!offer || !isLinkToOffer(linkType, isReview)) {
      t0 = href;
      break bb0;
    }
    let t1;
    if ($[0] !== href || $[1] !== linkType || $[2] !== offer.isMonetizing || $[3] !== offer.offerId || $[4] !== pathname || $[5] !== skuViewedPayload) {
      t1 = applyChaseLandingPage(href, {
        offerId: offer.offerId,
        isMonetizing: offer.isMonetizing,
        pathname,
        skuViewedPayload,
        ctaType: linkType
      });
      $[0] = href;
      $[1] = linkType;
      $[2] = offer.isMonetizing;
      $[3] = offer.offerId;
      $[4] = pathname;
      $[5] = skuViewedPayload;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = t1;
  }
  const landingPageHref = t0;
  let t1;
  if ($[7] !== landingPageHref || $[8] !== offer?.offerId || $[9] !== pathname || $[10] !== skuViewedPayload) {
    t1 = () => {
      if (!skuViewedPayload || !isChaseLandingPageLink(landingPageHref)) {
        return;
      }
      const defaulted = listParamsThatFellBackToDefaults(skuViewedPayload);
      const alreadyReported = reportedRef.current === landingPageHref;
      if (!defaulted.length || alreadyReported) {
        return;
      }
      reportedRef.current = landingPageHref;
      datadogRum.addAction("Chase landing page redirect is missing roundup context", {
        defaulted,
        href: landingPageHref,
        offerId: offer?.offerId,
        pathname
      });
    };
    $[7] = landingPageHref;
    $[8] = offer?.offerId;
    $[9] = pathname;
    $[10] = skuViewedPayload;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== landingPageHref || $[13] !== offer || $[14] !== pathname || $[15] !== skuViewedPayload) {
    t2 = [landingPageHref, offer, pathname, skuViewedPayload];
    $[12] = landingPageHref;
    $[13] = offer;
    $[14] = pathname;
    $[15] = skuViewedPayload;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  useEffect(t1, t2);
  return landingPageHref;
}